/* eslint-disable indent */
/* eslint-disable camelcase */
import store from '../../store'
import { setPedestrianScores } from '../slices/criteriaSelection/pedestrian'
import {
  ACTIVE_BUILDING_FRONTAGE,
  ACTIVE_BUILDING_FRONTAGE_VALUES,
  BUFFER_QUALITY,
  BUFFER_QUALITY_VALUES,
  BUFFER_WIDTH,
  BUFFER_WIDTH_VALUES,
  COMFORT_ZONE_WIDTH,
  COMFORT_ZONE_WIDTH_VALUES,
  CROSSING_IMPROVEMENTS,
  CROSSING_SPACING,
  CROSSING_SPACING_VALUES,
  HEAVY_VEHICLES,
  HEAVY_VEHICLES_VALUES,
  LANDSCAPE_BUFFER_STREET_TREES,
  LANDSCAPE_BUFFER_STREET_TREES_VALUES,
  LIGHTING,
  LIGHTING_VALUES,
  PEDESTRIAN_FACILITY_TYPE_VALUES,
  SIDEWALK_ACCESSIBILITY,
  SIDEWALK_ACCESSIBILITY_VALUES,
  SIDEWALK_QUALTIY,
  SIDEWALK_QUALTIY_VALUES,
  SPECIAL_CONSIDERATIONS,
  USABLE_SIDEWALK_WIDTH,
  USABLE_SIDEWALK_WIDTH_VALUES
} from '../constants/pedestrian'
import { NA } from '../constants/scores'

export function calculatePedestrianScore(field, facilityTypeChanged) {
  const { pedestrian, roadwayVariables, modalTiers } = store.getState()
  const { Pedestrian: PTier } = modalTiers
  const {
    pedestrian_facility_type,
    special_considerations,
    crossing_improvements
  } = pedestrian
  const { travel_lanes, prevailing_posted_speed } = roadwayVariables

  // If Pedestrian Tier is 0 or NA , do not calculate score
  // Every score is NA
  if (PTier === 0) {
    for (const key of Object.keys(pedestrian)) {
      store.dispatch(
        setPedestrianScores({
          field: key,
          value: NA
        })
      )
    }
    return
  }

  /** ----------ATTACHED OR DETACHED SIDEWALK-----------  */
  if (
    pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0] ||
    pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]
  ) {
    for (const key of Object.keys(pedestrian)) {
      switch (key) {
        case BUFFER_WIDTH:
          // Calcualte lane score and speed score based on Buffer width , only when Pedestrian Facility type is DETACHED SIDEWALK
          if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[0]) {
            if (pedestrian[key] === BUFFER_WIDTH_VALUES[0]) {
              // Dispatch for score for lanes and speed when Buffer width changes
              if (key === field || facilityTypeChanged) {
                // Calculate speed score
                prevailing_posted_speed <= 35
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 1
                      })
                    )
                  : prevailing_posted_speed >= 36 &&
                    prevailing_posted_speed < 40
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 2
                      })
                    )
                  : prevailing_posted_speed >= 40
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 4
                      })
                    )
                  : store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: NA
                      })
                    )
                // Calculate lane score
                travel_lanes <= 5
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 1
                      })
                    )
                  : travel_lanes >= 6
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 2
                      })
                    )
                  : store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: NA
                      })
                    )
              }
            } else if (pedestrian[key] === BUFFER_WIDTH_VALUES[1]) {
              if (key === field || facilityTypeChanged) {
                // Calculate speed score

                prevailing_posted_speed <= 30
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 1
                      })
                    )
                  : prevailing_posted_speed >= 31 &&
                    prevailing_posted_speed <= 35
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 2
                      })
                    )
                  : prevailing_posted_speed >= 36
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 4
                      })
                    )
                  : store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: NA
                      })
                    )
                // Calculate lane score
                travel_lanes <= 3
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 1
                      })
                    )
                  : travel_lanes === 4 || travel_lanes === 5
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 3
                      })
                    )
                  : travel_lanes >= 6
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 4
                      })
                    )
                  : store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: NA
                      })
                    )
              }
            } else {
              if (facilityTypeChanged) {
                store.dispatch(
                  setPedestrianScores({
                    field: 'prevailing_posted_speed',
                    value: NA
                  })
                )
                store.dispatch(
                  setPedestrianScores({
                    field: 'travel_lanes',
                    value: NA
                  })
                )
              }
            }
          } else if (
            pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]
          ) {
             prevailing_posted_speed <= 30
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 1
                      })
                    )
                  : prevailing_posted_speed >= 31 &&
                    prevailing_posted_speed <= 35
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 3
                      })
                    )
                      : prevailing_posted_speed > 35
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 4
                      })
                    )
                  : store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: NA
                      })
                    )

                      // Calculate lane score
                travel_lanes >= 2 && travel_lanes <= 3
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 1
                      })
                    )
                  : travel_lanes >= 4 && travel_lanes <= 5
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 3
                      })
                    )
                    : travel_lanes >= 6
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 4
                      })
                    )
                  : store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: NA
                      })
                    )
          } else if (
            pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[2]
          ) {
             prevailing_posted_speed < 10
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 1
                      })
                    )
                  : prevailing_posted_speed >= 11 &&
                    prevailing_posted_speed <= 15
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 2
                      })
                    )
                     : prevailing_posted_speed >= 16 &&
                    prevailing_posted_speed <= 20
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 3
                      })
                    )
                        : prevailing_posted_speed > 20
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: 4
                      })
                    )
                  : store.dispatch(
                      setPedestrianScores({
                        field: 'prevailing_posted_speed',
                        value: NA
                      })
                    )

                      // Calculate lane score
                travel_lanes <= 1
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 1
                      })
                    )
                  : travel_lanes >= 2
                  ? store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: 4
                      })
                    )
                  : store.dispatch(
                      setPedestrianScores({
                        field: 'travel_lanes',
                        value: NA
                      })
                    )
          }
          break
        case COMFORT_ZONE_WIDTH:
          if (field === key) {
            store.dispatch(setPedestrianScores({ field, value: NA }))
          }
          // update all values when pedestrian facility type changes
          if (facilityTypeChanged) {
            store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case SIDEWALK_ACCESSIBILITY:
          if (pedestrian[key] === SIDEWALK_ACCESSIBILITY_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (pedestrian[key] === SIDEWALK_ACCESSIBILITY_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === SIDEWALK_ACCESSIBILITY_VALUES[2]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }

          break

        case BUFFER_QUALITY:
          // In case of detached sidewalk , Buffer Quality is not considered for scoring
          if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
            break
          }

          if (pedestrian[key] === BUFFER_QUALITY_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === BUFFER_QUALITY_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (pedestrian[key] === BUFFER_QUALITY_VALUES[2]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case LANDSCAPE_BUFFER_STREET_TREES:
          // In case of detached sidewalk , Landscape is not considered for scoring
          if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
            break
          }

          if (pedestrian[key] === LANDSCAPE_BUFFER_STREET_TREES_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (
            pedestrian[key] === LANDSCAPE_BUFFER_STREET_TREES_VALUES[1]
          ) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (
            pedestrian[key] === LANDSCAPE_BUFFER_STREET_TREES_VALUES[2]
          ) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break

        case SIDEWALK_QUALTIY:
          if (pedestrian[key] === SIDEWALK_QUALTIY_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === SIDEWALK_QUALTIY_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          } else if (pedestrian[key] === SIDEWALK_QUALTIY_VALUES[2]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 4 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case USABLE_SIDEWALK_WIDTH:
          if (pedestrian[key] === USABLE_SIDEWALK_WIDTH_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === USABLE_SIDEWALK_WIDTH_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (pedestrian[key] === USABLE_SIDEWALK_WIDTH_VALUES[2]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          } else if (pedestrian[key] === USABLE_SIDEWALK_WIDTH_VALUES[3]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 4 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case LIGHTING:
          if (pedestrian[key] === LIGHTING_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === LIGHTING_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (pedestrian[key] === LIGHTING_VALUES[2]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 4 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case HEAVY_VEHICLES:
          if (pedestrian[key] === HEAVY_VEHICLES_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === HEAVY_VEHICLES_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (pedestrian[key] === HEAVY_VEHICLES_VALUES[2]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 4 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case ACTIVE_BUILDING_FRONTAGE:
          if (pedestrian[key] === ACTIVE_BUILDING_FRONTAGE_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === ACTIVE_BUILDING_FRONTAGE_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case CROSSING_SPACING:
          if (pedestrian[key] === CROSSING_SPACING_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            // update all values when pedestrian facility type changes and that particular field exsists
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === CROSSING_SPACING_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case SPECIAL_CONSIDERATIONS:
          if (pedestrian[key].length === 1) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else {
            key === field &&
              !special_considerations.length &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            facilityTypeChanged &&
              !special_considerations.length &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          }
          break
        case CROSSING_IMPROVEMENTS:
          if (pedestrian[key].length >= 2) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key].length === 1) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (pedestrian[key].length === 0) {
            key === field &&
              !crossing_improvements.length &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          }
          break
        default:
      }
    }

    // In case of Attached sidewalk , calculate lane and speed score
    if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[1]) {
      prevailing_posted_speed >= 0 && prevailing_posted_speed <= 30
        ? store.dispatch(
            setPedestrianScores({ field: 'prevailing_posted_speed', value: 1 })
          )
        : prevailing_posted_speed > 30 && prevailing_posted_speed <= 35
        ? store.dispatch(
            setPedestrianScores({ field: 'prevailing_posted_speed', value: 3 })
          )
        : store.dispatch(
            setPedestrianScores({ field: 'prevailing_posted_speed', value: 4 })
          )
      // Lanes Scores
      travel_lanes >= 1 && travel_lanes <= 3
        ? store.dispatch(
            setPedestrianScores({ field: 'travel_lanes', value: 1 })
          )
        : travel_lanes >= 4 && travel_lanes <= 5
        ? store.dispatch(
            setPedestrianScores({ field: 'travel_lanes', value: 3 })
          )
        : store.dispatch(
            setPedestrianScores({ field: 'travel_lanes', value: 4 })
          )
    }
  } else if (pedestrian_facility_type === PEDESTRIAN_FACILITY_TYPE_VALUES[2]) {
    /** ----------NO SIDEWALK-----------  */
    for (const key of Object.keys(pedestrian)) {
      switch (key) {
        case BUFFER_QUALITY:
          if (key === field) {
            store.dispatch(setPedestrianScores({ field, value: NA }))
          }
          facilityTypeChanged &&
            store.dispatch(setPedestrianScores({ field: key, value: NA }))
          break
        case USABLE_SIDEWALK_WIDTH:
          if (key === field) {
            store.dispatch(setPedestrianScores({ field, value: NA }))
          }
          facilityTypeChanged &&
            store.dispatch(setPedestrianScores({ field: key, value: NA }))
          break
        case LANDSCAPE_BUFFER_STREET_TREES:
          if (key === field) {
            store.dispatch(setPedestrianScores({ field, value: NA }))
          }
          facilityTypeChanged &&
            store.dispatch(setPedestrianScores({ field: key, value: NA }))
          break
        case SIDEWALK_QUALTIY:
          if (key === field) {
            store.dispatch(setPedestrianScores({ field, value: NA }))
          }
          facilityTypeChanged &&
            store.dispatch(setPedestrianScores({ field: key, value: NA }))
          break
        case SIDEWALK_ACCESSIBILITY:
          if (key === field) {
            store.dispatch(setPedestrianScores({ field, value: NA }))
          }
          facilityTypeChanged &&
            store.dispatch(setPedestrianScores({ field: key, value: NA }))

          break
        case CROSSING_IMPROVEMENTS:
          if (key === field) {
            store.dispatch(setPedestrianScores({ field, value: NA }))
          }
          facilityTypeChanged &&
            store.dispatch(setPedestrianScores({ field: key, value: NA }))

          break
        case ACTIVE_BUILDING_FRONTAGE:
          if (key === field) {
            store.dispatch(setPedestrianScores({ field, value: NA }))
          }
          facilityTypeChanged &&
            store.dispatch(setPedestrianScores({ field: key, value: NA }))
          break
        case COMFORT_ZONE_WIDTH:
          if (pedestrian[key] === COMFORT_ZONE_WIDTH_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === COMFORT_ZONE_WIDTH_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break

        case LIGHTING:
          if (pedestrian[key] === LIGHTING_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === LIGHTING_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (pedestrian[key] === LIGHTING_VALUES[2]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 4 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case HEAVY_VEHICLES:
          if (pedestrian[key] === HEAVY_VEHICLES_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === HEAVY_VEHICLES_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else if (pedestrian[key] === HEAVY_VEHICLES_VALUES[2]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 4 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 4 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: NA }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: NA }))
          }
          break
        case CROSSING_SPACING:
          if (pedestrian[key] === CROSSING_SPACING_VALUES[0]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          } else if (pedestrian[key] === CROSSING_SPACING_VALUES[1]) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 3 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 3 }))
          }
          break
        case SPECIAL_CONSIDERATIONS:
          if (pedestrian[key].length === 1) {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 2 }))
            facilityTypeChanged &&
              store.dispatch(setPedestrianScores({ field: key, value: 2 }))
          } else {
            key === field &&
              store.dispatch(setPedestrianScores({ field, value: 1 }))
            facilityTypeChanged &&
              !special_considerations.length &&
              store.dispatch(setPedestrianScores({ field: key, value: 1 }))
          }
          break

        default:
      }
    }

    // In case of NO  sidewalk , calculate lane and speed score

    prevailing_posted_speed >= 0 && prevailing_posted_speed <= 10
      ? store.dispatch(
          setPedestrianScores({ field: 'prevailing_posted_speed', value: 1 })
        )
      : prevailing_posted_speed >= 11 && prevailing_posted_speed <= 15
      ? store.dispatch(
          setPedestrianScores({ field: 'prevailing_posted_speed', value: 2 })
        )
      : prevailing_posted_speed >= 16 && prevailing_posted_speed <= 20
      ? store.dispatch(
          setPedestrianScores({ field: 'prevailing_posted_speed', value: 3 })
        )
      : store.dispatch(
          setPedestrianScores({ field: 'prevailing_posted_speed', value: 4 })
        )
    // Lanes Scores
    travel_lanes === 1
      ? store.dispatch(setPedestrianScores({ field: 'travel_lanes', value: 1 }))
      : store.dispatch(setPedestrianScores({ field: 'travel_lanes', value: 4 }))
  }
}
